import { html, paragraphs } from '../lib/html.js';
import { icon } from '../lib/icons.js';
import { concept, loadVerse } from '../lib/content.js';
import { topbar } from '../components/chrome.js';
import { verseRow } from '../components/verse.js';
import notfound from './notfound.js';

export default async function conceptView({ id }) {
  const g = concept(id);
  if (!g) return notfound();
  const verses = await Promise.all(g.verses.map(async (vid) => ({ vid, v: await loadVerse(vid) })));
  const related = g.related.map((r) => concept(r)).filter(Boolean);
  return {
    title: g.term,
    html: html`<div class="concept">
      ${topbar({ back: '/concepts', title: g.term })}
      <header class="wrap page-head concept__head">
        <p class="concept__sa deva" lang="sa">${g.sa}</p>
        <h1 class="h1">${g.term}</h1>
        <p class="concept__iast iast" lang="sa-Latn">${g.iast}</p>
        <p class="lede concept__short">${g.short}</p>
      </header>
      <div class="wrap">
        <div class="prose concept__body">${paragraphs(g.body)}</div>
        <section class="section" aria-labelledby="where-title">
          <div class="section__head"><h2 class="h3" id="where-title">Key verses</h2>${g.tagged.length ? html`<span class="small muted">Tagged in ${g.tagged.length} verses</span>` : ''}</div>
          <div class="verse-rows">${verses.filter((x) => x.v).map(({ vid, v }) => verseRow(Number(vid.split('.')[0]), v))}</div>
        </section>
        ${related.length ? html`<section class="section" aria-labelledby="rel-title">
          <h2 class="h3" id="rel-title" style="margin-bottom:12px">Related ideas</h2>
          <div class="chips">${related.map((r) => html`<a class="chip" href="/concept/${r.id}"><span class="chip__deva" lang="sa">${r.sa}</span>${r.term}</a>`)}</div>
        </section>` : ''}
        <p class="section"><a class="link" href="/concepts">${icon('arrow-left', { size: 16 })} All key ideas</a></p>
      </div>
    </div>`,
  };
}
